module.exports = __webpack_public_path__ + "static/images/calendar-checkmark.1f4c56db364db7bedac7c0cbe5a901bc.svg";